class PdfService {
    static async getPdf(fileName) {
        const proxyUrl = `/api/pdf/${encodeURIComponent(fileName)}`;
        const response = await fetch(proxyUrl);

        if (!response.ok) {
            throw new Error(`Failed to fetch PDF: ${response.status} ${response.statusText}`);
        }

        const arrayBuffer = await response.arrayBuffer();
        return arrayBuffer;
    }

    static async getFileData(orderline) {
        const proxyUrl = `/api/effectmeasure/data/${encodeURIComponent(orderline)}`;
        const response = await fetch(proxyUrl);
        if (!response.ok) {
            throw new Error(`Failed to fetch metadata: ${response.statusText}`);
        }

        const jsonData = await response.json();
        return jsonData;
    }

    static async getEffectMeasurePdf(fileName) {
        const proxyUrl = `/api/effectmeasure/${encodeURIComponent(fileName)}`;
        const response = await fetch(proxyUrl);

        if (!response.ok) {
            throw new Error(`Failed to fetch PDF: ${response.status} ${response.statusText}`);
        }

        const arrayBuffer = await response.arrayBuffer();
        return arrayBuffer;
    }
}

export default PdfService;